export default "__VITE_ASSET__f6084a8e__"